import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'sr-complete',
    templateUrl: './sr-complete.component.html',
    styleUrls: ['./sr-complete.component.scss'],
    standalone: false
})
export class SrCompleteComponent implements OnInit {
  @Input() title: string = 'Modal Title'
  @Input() message: string = ''
  @Input() confirmText: string = 'OK'
  @Input() cancelText: string = 'Cancel'
  @Input() referenceNumber: string = 'CBMXXXXXXXXXXXX'
  @Input() visible: boolean = true;
  @Output() onDismiss: EventEmitter<any> = new EventEmitter()
  @Output() onConfirm: EventEmitter<any> = new EventEmitter()


  constructor() {
    //
  }

  ngOnInit() {
    //
  }

  confirm() {
    this.onConfirm.emit();
    this.onDismiss.emit();
    this.visible = false;
  }
  dismiss() {
    this.confirm();
  }

}
